import { createContext } from "react";

export const AppContext = createContext(
    {
        offline: false,
        page: {},
        setOffline: () => {},
        setPage: () => {},

        user: null,
        users: null,
        schoolUsers: null,
        data: null,
        tests: null,
        interrogations: null,
        homeworks: null,
        others: null,
        timetable: null,
        subjects: null,
        announcements: null,
        classPresidents: null,
        schoolPresidents: null,
        uploadingAttachments: [],
        sectionsOrder: null,
        editingSectionsOrder: false,
        flashCards: null,
        registerAccessToken: null,
        registerEvents: null,
        registerStudentId: null,
        
        setUser: () => {},
        setUsers: () => {},
        setSchoolUsers: () => {},
        setData: () => {},
        setTests: () => {},
        setInterrogations: () => {},
        setHomeworks: () => {},
        setOthers: () => {},
        setTimetable: () => {},
        setSubjects: () => {},
        deleteSubject: () => {}, 
        setAnnouncements: () => {},
        setClassPresidents: () => {},    
        setSchoolPresidents: () => {},    
        setNewEvents: () => {},   
        setUpdatedEvents: () => {},  
        setUploadingAttachments: () => {},
        setSectionsOrder: () => {},
        deleteSectionOrder: () => {},
        updateSectionOrder: () => {},
        setEditingSectionsOrder: () => {},
        setFlashCards: () => {}, 
        deleteFlashCards: () => {}, 
        updateFlashCards: () => {},
        setRegisterAccessToken: () => {},
        setRegisterEvents: () => {},
        updateRegisterEvents: () => {},
        deleteRegisterEvent: () => {},
        setRegisterStudentId: () => {},

        showNavBar: () => {},
        hideNavBar: () => {},
    }
);